// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}
._syaz1ml5{color:var(--_1xw92dq)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/checkbox/dist/esm/internal/required-indicator.compiled.css"],"names":[],"mappings":"AAAA,WAAW,4CAA4C;AACvD,WAAW,qBAAqB","sourcesContent":["._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}\n._syaz1ml5{color:var(--_1xw92dq)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
